var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"value":_vm.split.vatAmount,"disabled":"","outlined":"","label":_vm.$t('VAT_AMOUNT'),"type":"number","suffix":_vm.currency}}),(_vm.showVatAmountWarning)?_c('span',{class:_vm.$style.warningMessage},[_vm._v(_vm._s(_vm.$t('VAT_AMOUNT_WARNING')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }